import { client } from '@/proxy/client'
import { gql } from 'graphql-request'
import { keepPreviousData, useQuery } from '@/proxy/react-query'
import { UseOrderEditPreview, OrderEditPreviewProducts } from './types'

export const ORDER_EDIT_PREVIEW = gql`
  query orderEditPreview(
    $orderNumber: String!
    $orderItemsInput: [UseOrderEditProducts!]!
  ) {
    orderEditPreview(
      orderNumber: $orderNumber
      orderItemsInput: $orderItemsInput
    ) {
      items {
        variantId
        name
        amount
        unitPrice
        totalPrice
        image
      }
      charging {
        shippingFee
        subTotal
        discount
        cashback
        change
        total
        totalSamplingPrice
      }
      errors {
        message
        category
        target
        key
      }
    }
  }
`

export const useOrderEditPreview = (variables: {
  orderNumber: string
  orderItemsInput: OrderEditPreviewProducts[]
}) =>
  useQuery<UseOrderEditPreview>({
    queryKey: ['orderEditPreview', variables],
    queryFn: () => client.request(ORDER_EDIT_PREVIEW, variables),
    placeholderData: keepPreviousData,
  })
